import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="py-24 bg-sand-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-6">
            <i className="ri-flower-line text-2xl text-primary-600"></i>
          </div>
          <span className="text-primary-600 text-sm uppercase tracking-wider font-semibold mb-4 block">
            {t('about.label')}
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-6">
            {t('about.title')}
          </h2>
          <div className="flex items-center justify-center mb-8">
            <div className="h-px bg-sage-400 w-24"></div>
            <i className="ri-leaf-line text-sage-500 mx-4"></i>
            <div className="h-px bg-sage-400 w-24"></div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {/* Expert Guidance */}
          <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
            <div className="mb-6 flex justify-center">
              <div 
                className="w-full h-48 bg-cover bg-center rounded-2xl"
                style={{
                  backgroundImage: `url('https://public.readdy.ai/ai/img_res/e5e9c0ef5133f74bc079ab79c92f2790.jpg')`
                }}
              />
            </div>
            <h3 className="text-xl font-serif font-bold text-gray-900 mb-3">{t('about.expert.title')}</h3>
            <p className="text-gray-600 leading-relaxed">
              {t('about.expert.description')}
            </p>
            <div className="mt-4">
              <i className="ri-star-fill text-gold-500"></i>
            </div>
          </div>

          {/* Holistic Healing */}
          <div className="bg-sage-50 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
            <div className="mb-6 flex justify-center">
              <div 
                className="w-full h-48 bg-cover bg-center rounded-2xl"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=traditional%20ayurvedic%20medicine%20preparation%20with%20mortar%20pestle%20grinding%20fresh%20turmeric%20ginger%20herbs%20aromatic%20spices%20medicinal%20plants%20copper%20vessels%20ancient%20healing%20ingredients%20natural%20remedies%20holistic%20wellness%20authentic%20indian%20ayurveda&width=400&height=300&seq=ayurveda789&orientation=landscape')`
                }}
              />
            </div>
            <h3 className="text-xl font-serif font-bold text-gray-900 mb-3">{t('about.holistic.title')}</h3>
            <p className="text-gray-600 leading-relaxed">
              {t('about.holistic.description')}
            </p>
            <div className="mt-4">
              <i className="ri-heart-line text-primary-500"></i>
            </div>
          </div>

          {/* Nature Immersion */}
          <div className="bg-primary-50 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
            <div className="mb-6 flex justify-center">
              <div 
                className="w-full h-48 bg-cover bg-center rounded-2xl"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=person%20practicing%20mindful%20meditation%20on%20pristine%20Fuerteventura%20beach%20with%20golden%20sand%20dunes%20ocean%20waves%20gentle%20wind%20peaceful%20nature%20connection%20wellness%20journey%20spiritual%20awakening&width=400&height=300&seq=nature001&orientation=landscape')`
                }}
              />
            </div>
            <h3 className="text-xl font-serif font-bold text-gray-900 mb-3">{t('about.nature.title')}</h3>
            <p className="text-gray-600 leading-relaxed">
              {t('about.nature.description')}
            </p>
            <div className="mt-4">
              <i className="ri-leaf-line text-sage-500"></i>
            </div>
          </div>

          {/* Personalized Approach */}
          <div className="bg-gold-50 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
            <div className="mb-6 flex justify-center">
              <div 
                className="w-full h-48 bg-cover bg-center rounded-2xl"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=personalized%20ayurvedic%20consultation%20session%20with%20traditional%20constitution%20assessment%20dosha%20analysis%20customized%20wellness%20plan%20individual%20healing%20approach%20peaceful%20consultation%20room&width=400&height=300&seq=personal001&orientation=landscape')`
                }}
              />
            </div>
            <h3 className="text-xl font-serif font-bold text-gray-900 mb-3">{t('about.personalized.title')}</h3>
            <p className="text-gray-600 leading-relaxed">
              {t('about.personalized.description')}
            </p>
            <div className="mt-4">
              <i className="ri-user-heart-line text-gold-600"></i>
            </div>
          </div>
        </div>

        {/* Founder Introduction */}
        <div className="max-w-4xl mx-auto mb-20 bg-white rounded-3xl p-10 shadow-lg">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-primary-100 rounded-full mb-6">
              <i className="ri-heart-pulse-line text-2xl text-primary-600"></i>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('about.founder.intro')} <strong className="text-primary-700">{t('about.founder.name')}</strong>{t('about.founder.description')}
            </p>
          </div>
        </div>

        {/* Additional Content */}
        <div className="text-center max-w-4xl mx-auto">
          <p className="text-lg text-gray-700 leading-relaxed">
            {t('about.closing')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
